<template>
  <div class="reply_div" v-if="comment.regId !== userInfo.uniqId">
    <!-- :style="`background-image: url(${user.userInfo.myPhotoUrl}), url(/images/basic/img/default.svg) ;border-radius:50%` -->
    <template v-if="comment.userInfo == undefined">
      <div class="profile_pic" :style="`background-image: url(images/basic/img/default.svg);`"
        @click="reportCommentUser()"
      ></div>
    </template>
    <template v-else>
      <div class="profile_pic" :style="comment.userInfo.myPhotoUrl ? `background-image: url(${comment.userInfo.myPhotoUrl});` : `background-image: url(images/basic/img/default.svg);`"
        @click="reportCommentUser()"
      ></div>
    </template>
    <div class="text_box">
      <div class="in">
        <p>
          <span style="display: none">Lv.1</span> {{ comment.regNm }} <span class="time">{{ comment.timeFormat }}</span>
        </p>
        <p class="text" v-html="comment.commentContent.replace(/(?:\r\n|\r|\n)/g, '</br>')"></p>
        <div calss="btn_con"> 
          <div class="toggleBtn like" :class="comment.likeYn == 'N' ? '' : 'ed'" @click="likeComment(comment.commentId)"><i :class="comment.likeYn == 'far fa-heart' ? '' : 'far fa-heart'"></i> {{ comment.likeCnt }}</div>
          <div class="toggleBtn report" @click="reportComment()"><i class="fa fa-exclamation-triangle"/></div>
        </div>
      </div>
    </div>
  </div>
  <div class="reply_div mine" v-else>
    <div class="text_box">
      <div class="in">
        <p>
          나의 댓글 <span class="time">{{ comment.timeFormat }}</span>
        </p>
        <p class="text" v-html="comment.commentContent.replace(/(?:\r\n|\r|\n)/g, '</br>')"></p>
        <div class="edit_box">
          <div class="like" :class="comment.likeYn == 'N' ? '' : 'ed'">
            <i :class="comment.likeYn == 'far fa-heart' ? '' : 'far fa-heart'"></i>
            <!-- @click="likeComment(comment.commentId)" -->
            {{ comment.likeCnt }}
          </div>
          <span class="reply_del"><img src="images/basic/icon/trash-comment.svg" alt="" @click="deleteComment(comment.commentId, index)" /></span>
          <span class="reply_edit" :id="comment.commentId"><img src="images/basic/icon/comment-edit.svg" alt="" @click="openUdtBox(comment.commentId, index)" /></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    comment: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    likeToggle() {
      return this.comment.likeYn;
    },
  },
  methods: {
    likeComment(commentId) {
      this.$emit("likeComment", commentId);
    },
    deleteComment(commentId, idx) {
      this.$emit("deleteComment", commentId, idx);
    },
    openUdtBox(commentId, idx) {
      this.$emit("openUdtBox", commentId, idx);
    },
    reportComment(){
      this.$emit("reportComment",this.comment);
    },
    reportCommentUser(){
      this.$emit("reportCommentUser",this.comment);
    }
  },
};
</script>

<style scoped>
.community_reply_wrapper {
  padding: 20px 20px calc(95px + var(--safebottomenv)) 20px;
}
.community_reply_wrapper p {
  font-size: 1.125em;
  line-height: 30px;
}
.community_reply_wrapper p span {
  color: var(--Main-color);
}
.community_reply_wrapper .reply_div {
  padding-top: 20px;
  display: flex;
}
.community_reply_wrapper .profile_pic {
  padding-left: 0;
  padding-right: 0;
  margin-right: 20px;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  flex-grow: 0;
  background-size: cover;
  background-position: center;
}
.community_reply_wrapper .text_box {
  position: relative;
  width: auto;
  height: auto;
  padding: 0px;
  background: #f2f3f6;
  -webkit-border-radius: 0.625em;
  -moz-border-radius: 0.625em;
  border-radius: 0.625em;
  display: inline-block;
}
.community_reply_wrapper .text_box:after {
  content: "";
  position: absolute;
  border-style: solid;
  border-width: 1.333vw 0.625em 1.333vw 0;
  border-color: transparent #f2f3f6;
  display: block;
  width: 0;
  z-index: 1;
  left: -0.625em;
  top: 4vw;
}
.liked {
  color: var(--Red) !important;
}
.community_reply_wrapper .text_box .con {
  padding: 5.333vw;
}
.community_reply_wrapper .text_box div div {
  font-size: 0.75em;
  line-height: 20px;
  display: inline-block;
  width: 100%;
  font-weight: bold;
}
.community_reply_wrapper .text_box div div div,
.community_reply_wrapper .text_box .toggleBtn {
  display: inline;
  font-size: 12px;
  font-weight: normal;
}
.community_reply_wrapper .text_box .toggleBtn.report{
  float: right;
  width: 16px;
}
.community_reply_wrapper .text_box div .time {
  color: #9ea3ab;
  line-height: 20px;
  float: right;
  font-weight: normal;
}
.community_reply_wrapper .text_box div .text {
  font-size: 0.875em;
  padding-top: 1.333vw;
  font-weight: normal;
}
.community_reply_wrapper .text_box .in {
  padding: 15px;
}
.community_reply_wrapper .text_box div div:last-child {
  color: #9ea3ab;
  font-weight: normal;
  /*margin-top: 10px;*/
}
.community_reply_wrapper .mine {
  color: #fff;
  justify-content: flex-end;
}
.community_reply_wrapper .mine .text_box {
  margin-right: 20px;
  flex-shrink: 1;
  text-align: left;
  background: #6f737a;
}
.community_reply_wrapper .mine .text_box:after {
  border-width: 1.333vw 0 1.333vw 12px;
  border-color: transparent #6f737a;
  left: auto;
  right: -2.667vw;
}
.community_reply_wrapper .mine .text_box div p {
  color: white;
}
.community_reply_wrapper .mine .text_box .reply_del,
.community_reply_wrapper .mine .text_box .reply_edit {
  float: right;
  color: white;
  margin-left: 26px;
}
</style>
